module.exports = __webpack_public_path__ + "img/6_11.f860293a.png";